import { Stack } from '@startuptools/ui/Stack';
import { Box } from '@startuptools/ui/Box';
import { useTheme } from '@startuptools/ui/Theme';
import { TemplatesCard } from '../TemplatesCard';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Button {
  text: string;
  tooltipTitle: string;
  url: string[];
  docKinds: string[];
}

interface CardInfo {
  buttons: Button[];
  title: string;
  iconName: string;
  referToUrl: string;
}

export interface CardData {
  cardGroup: CardInfo[];
}

export const MainCardRow = ({
  cardData,
  spacing,
  marginRightFirstEle,
}: {
  cardData: CardData[];
  spacing: number;
  marginRightFirstEle: number;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
      {cardData.map((card, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'center' : 'start',
            justifyContent: isMobile ? 'center' : 'start',
            marginRight: index === 0 ? `${marginRightFirstEle}rem` : '0rem',
            alignSelf: isMobile ? 'center' : 'initial',
          }}
        >
          <Stack
            spacing={spacing}
            sx={{
              marginBottom: isMobile ? '1.5rem' : '0rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: isMobile ? 'center' : 'start',
              justifyContent: isMobile ? 'center' : 'start',
            }}
          >
            {card.cardGroup.map(templateCard => (
              <TemplatesCard key={templateCard.title} {...templateCard} />
            ))}
          </Stack>
        </Box>
      ))}
    </Box>
  );
};
